import React, { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { getSelectedGradGroupData, setMeasurmentDetails } from '../store/DevelopmentOrder.action';
import { fetchTrafficLights } from '../Bom/store/BOMConfig.action';
import Annotation from '../../../Components/Utility/Annotation/SampleSupplierAnnotation';
import Loader from '../../../Components/Utility/Loader/Loader';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function MarkerMeasurment({ productGradingMeasurements, setMeasurmentDetails, fetchTrafficLights }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [count, setCount] = useState(-1);
  const [currentImage, setCurrentImage] = useState({
    annotatedImage: '',
    markerObj: {},
    imageSrc: '',
    code: '',
    desc: '',
  });
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const { devOrderId, type, gradingGroupId, code } = useParams();
  const [measurementPomLibraries, setMeasurementPomLibraries] = useState([]);

  const initialExicution = async () => {
    const param = {
      devOrderId,
      gradingGroupId,
    };

    await fetchTrafficLights(devOrderId);
    await dispatch(getSelectedGradGroupData(param));
    setLoader(false);
  };

  useEffect(() => {
    initialExicution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (measurementPomLibraries?.length) {
      const result = measurementPomLibraries?.find((elem) => elem?.code === measurementPomLibraries[count]?.code);
      if (result) {
        setCurrentImage({
          annotatedImage: result.annotatedImage ? result.annotatedImage : result.image,
          markerObj: result.markerObj ? result.markerObj : {},
          imageSrc: result.image,
          code: result.code,
          desc: result.description,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  useEffect(() => {
    if (productGradingMeasurements) {
      if (type === 'spec-pom') {
        setMeasurementPomLibraries(productGradingMeasurements?.specPomLibraries);
      }

      if (type === 'cad-pom') {
        setMeasurementPomLibraries(productGradingMeasurements?.pomLibraries);
      }
    }
  }, [productGradingMeasurements]);

  useEffect(() => {
    if (measurementPomLibraries?.length) {
      setTotalCount(measurementPomLibraries.length - 1);
      const result = measurementPomLibraries.find((elem) => elem.code === code);
      const index = measurementPomLibraries.findIndex((x) => x.code === code);
      setCount(index);
      if (result?.image) {
        setCurrentImage({
          annotatedImage: result.annotatedImage ? result.annotatedImage : result.image,
          markerObj: result.markerObj ? result.markerObj : {},
          imageSrc: result.image,
          code: result.code,
          desc: result.description,
        });
      }
    }
  }, [measurementPomLibraries, code]);

  const onEditModeOn = async (val) => {
    setIsEditOpen(val);
  };

  const onSave = async (obj, newObj, updatedUrl) => {
    // Post Api For data in Database
    if (JSON.stringify(obj.markers) !== JSON.stringify(newObj.markers)) {
      setLoader(true);
      const postParams = {
        devOrderId,
        gradingGroupId,
        type,
        code: currentImage.code,
        annotatedImage: updatedUrl,
        markerObj: obj,
      };
      const result = await setMeasurmentDetails(postParams, t);
      if (result) {
        const param = {
          devOrderId,
          gradingGroupId,
        };

        await dispatch(getSelectedGradGroupData(param));
      }
      setLoader(false);
    }
  };

  const handleNext = () => {
    setCount(count + 1);
  };

  const handlePrevious = () => {
    setCount(count - 1);
  };

  const sampleImgSet = () => {
    return currentImage.annotatedImage ? currentImage.annotatedImage : currentImage.imageSrc;
  };

  const annotationCalled = () => {
    return currentImage.imageSrc ? (
      <Annotation
        sampleImage={sampleImgSet()}
        sourceImage={currentImage.imageSrc}
        markerObj={currentImage.markerObj}
        onSaveAnnotation={onSave}
        setIsEditOpen={onEditModeOn}
      />
    ) : (
      <div className="text-center pt-20per">{t('DEVLOPMENT_ORDER.MEASUREMENT.MARKER_MEASURMENT.NO_IMAGE_FOUND')}</div>
    );
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('DEVLOPMENT_ORDER.MEASUREMENT.MEASUREMENTS.SPECIFICATIONS')}</h4>
          <div className="referance-code d-flex pr-0">
            &nbsp;
            {currentImage.code}
            {' - '}
            <CustomTooltip tooltipText={currentImage.desc}>
              <span className="pl-1 truncate-desc">{currentImage.desc}</span>
            </CustomTooltip>
          </div>
        </div>
        <div>
          <button className="p-0 border-0 bg-transparent">
            <Link
              to={`/development-order/${devOrderId}/measurement`}
              aria-label={t('COMMON_LABEL.CLOSE')}
              className="btn p-0"
              style={{ textDecoration: 'none' }}
            >
              <i className="icon-close f-20" />
            </Link>
          </button>
        </div>
      </div>
      {loader ? (
        <Loader />
      ) : (
        <div className="container-fluid">
          <div className="row justify-content-center pt-3" style={{ marginBottom: '50px' }}>
            <div className="col-lg-11">
              {annotationCalled()}
              <button className="btn-marker-nav next" aria-label="next" type="button" onClick={handleNext} disabled={count === totalCount || isEditOpen}>
                <span className="iconify" data-icon="grommet-icons:next" />
              </button>
              <button className="btn-marker-nav prev" aria-label="previous" type="button" onClick={handlePrevious} disabled={count === 0 || isEditOpen}>
                <span className="iconify" data-icon="grommet-icons:previous" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = ({ Measuremets }) => {
  const { productGradingMeasurements } = Measuremets;
  return { productGradingMeasurements };
};

const mapStateToDispatch = {
  getSelectedGradGroupData,
  setMeasurmentDetails,
  fetchTrafficLights,
};

export default connect(mapStateToProps, mapStateToDispatch)(MarkerMeasurment);
